import React from 'react';
import { Divider } from 'semantic-ui-react';
import { arrayOf, shape, string } from 'prop-types';

import LiveCard from './LiveCard';

const Episodes = ({ publishedItems, terms }) => (
  <React.Fragment>
    <Divider inverted horizontal>
      {terms[1]}
    </Divider>
    {publishedItems.map((item, i) => (
      <LiveCard {...item} key={item.id} index={i} terms={terms} />
    ))}
  </React.Fragment>
);

Episodes.propTypes = {
  publishedItems: arrayOf(shape).isRequired,
  terms: arrayOf(string).isRequired,
};

export default Episodes;



// WEBPACK FOOTER //
// ./src/components/Feed/Episodes.jsx